import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Tooltip } from "@mui/material";
import ConfigData from "../config/config.json";
import { GlobalMessageContext } from "../app/App";

const webserver = ConfigData.WEBSERVER;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function ScenarioSelector(props) {
  const [allScenarios, setAllScenarios] = React.useState([]);
  const { setGlobalMessage } = React.useContext(GlobalMessageContext);
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    // On autofill we get a stringified value.
    const returnValue = typeof value === "string" ? value.split(",") : value;

    if (props.index === undefined) {
      props.setSelectedScenarios(returnValue);
    } else {
      fetch(
        webserver.protocol +
          "://" +
          webserver.host +
          ":" +
          webserver.port +
          "/recipe/setScenarios/" +
          props.id,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(returnValue),
        }
      )
        .then((response) => {
          if (response.status !== 200) {
            throw new Error("Unable to access endpoint: recipe/setScenarios");
          }
          return response;
        })
        .then((response) => response.json())
        .then((data) => {
          props.setSelectedScenarios((prev) => {
            let temp = JSON.parse(JSON.stringify(prev));
            temp[props.index].scenarios = returnValue;
            return temp;
          });
          setGlobalMessage({
            globalMessage: "Änderung erfolgreich",
            severity: "success",
          });
        })
        .catch((error) => {
          setGlobalMessage({
            globalMessage: "Vorgang fehlgeschlagen",
            severity: "error",
          });
        });
    }
  };

  React.useEffect(() => {
    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/scenario/getAll",
      { method: "GET", credentials: "include" }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Error: " + response.status);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        setAllScenarios(data);
      })
      .catch((error) => {
        //TODO global error cannot load user table
      });
  }, []);

  return (
    <div>
      <FormControl sx={{ width: props.width }} size="small">
        <InputLabel id="demo-multiple-checkbox-label">
          Mögliche Szenarien
        </InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={props.selectedScenarios}
          onChange={(e) => handleChange(e)}
          input={<OutlinedInput label="Mögliche Szenarien" />}
          renderValue={(selected) => selected.join(", ")}
          MenuProps={MenuProps}
        >
          {props.selectedScenarios.map((scenario) => (
            <MenuItem key={scenario} value={scenario}>
              <Checkbox
                checked={props.selectedScenarios.indexOf(scenario) > -1}
              />
              <Tooltip title={scenario} enterDelay={1000}>
                <ListItemText primary={scenario} />
              </Tooltip>
            </MenuItem>
          ))}

          {allScenarios.map((scenario) =>
            props.selectedScenarios.indexOf(scenario.title) <= -1 ? (
              <MenuItem key={scenario.title} value={scenario.title}>
                <Checkbox checked={false} />
                <Tooltip title={scenario.title} enterDelay={1000}>
                  <ListItemText primary={scenario.title} />
                </Tooltip>
              </MenuItem>
            ) : null
          )}
        </Select>
      </FormControl>
    </div>
  );
}
